export function loadNuveiSDK() {
  if (window.SafeCharge) return window.SafeCharge;
  return new Promise((resolve, reject) => {
    if (window.SafeCharge) return resolve(window.SafeCharge);
    const script = document.createElement("script");
    script.src =
      "https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js";
    script.onload = () => resolve(window.SafeCharge);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
